import React from 'react';
import '../style.css'
import styles from '../index.module.css'
import clsx from 'clsx'
import CheckCircle from '../../../../assets/journaler/solutions/CheckCircle.png'


const FeatureContentList = ({ content }) => (
  <div className={clsx('row', styles.reportingFeatureItem)}>
    <div className={clsx('col col-1', styles.reportingTickContainer)}>
      <img src={CheckCircle} alt='tick' className={styles.reportingTick} />
    </div>
    <div className={clsx('col', styles.subReport)}>
      <p className={styles.reportingFeatureText}>{content}</p>
    </div>
  </div>
)


const WalletConnectionMobile = (props) => {
  return (
    <div className='row pl-3 pt-3 pr-3 pb-3'>
      <div className='col-12 d-flex justify-content-center'>
        <img className='img-fluid  image-wallet' src={props.image} alt="Responsive image" />
      </div>
      <div className='col-12 '>

        <div className='header-report'>
          <div className='pt-3 pb-3'>
            {props.content.header}
          </div>

          <div>
            {props.content.content.map((content, index) => (
              <FeatureContentList key={index} content={content} />
            ))}
          </div>

        </div>
      </div>

    </div>
  )
}

export default WalletConnectionMobile